import { UserPermissions } from '@centecomm/portal-service';
import React from 'react';
import { FeatureConfiguration } from '../../Core/Types/FeatureConfiguration';
import ReportsNavigationIcon from '../../Icons/NavigationItem/Reports';
import { LoadingContent } from '../../Shared/PageElements/LoadingContent';

const LazyReportsPage = React.lazy(() => import('./Pages/ReportsPage'));

const reportsConfiguration: FeatureConfiguration = {
    name: 'Reports',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureReportsTitle',
            url: '/reports',
            Icon: ReportsNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyReportsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        permissions: [UserPermissions.ViewReports],
    },
    disableFeature: [],
    checkIfEnabledViaSettings: (settings) => {
        if (settings && settings.report) {
            return settings.report.visible;
        }

        return false;
    },
};

export default reportsConfiguration;
